/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useRef } from "react";
import {
  Box,
  CircularProgress,
  ImageList,
  ImageListItem,
  //   Skeleton,
} from "@mui/material";
import { useImmer } from "use-immer";

const Gallery = ({ imageData }) => {
  // Data
  const [state, produce] = useImmer({
    imgIndex: 0,
    imgLoading: true,
  });
  const { imgIndex, imgLoading } = state;
  const mainImgRef = useRef();

  // CSS
  const imgHolder = css({
    width: 500,
    height: 400,
    position: "relative",
    margin: "auto",
  });
  const progressHolder = css({
    position: "absolute",
    zIndex: 5,
    width: 500,
    height: 400,
    backgroundColor: "#000000AA",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });

  const mainImg = css({
    objectFit: "contain",
    filter: imgLoading ? "blur(3px)" : "none",
  });
  const subImg = css({
    border: "0.5px solid lightgray",
    overflow: "hidden",
  });

  // Method
  const onClickImg = (index) => {
    if(index === imgIndex){
      return ;
    }
    produce((draft) => {
      draft.imgIndex = index;
      draft.imgLoading = true;
    });
  };
  const onImgLoadFinish = () => {
    produce((draft) => void (draft.imgLoading = false));
  };

  return (
    <>
      <Box css={imgHolder}>
        {imageData.length > 0 && imgLoading && (
          <Box css={progressHolder}>
            <CircularProgress />
          </Box>
        )}
        {imageData.length > 0 ? (
          <img
            ref={mainImgRef}
            width={500}
            height={400}
            src={imageData[imgIndex].img}
            alt={imageData[imgIndex].title}
            css={mainImg}
            onLoad={() => onImgLoadFinish()}
            onError={() => {
              onImgLoadFinish();
              mainImgRef.current.src =
                process.env.PUBLIC_URL + "/ImageNotFound.jpg";
            }}
          />
        ) : 
        (<img
          width={500}
          height={400}
          alt="NotFount"
          src={process.env.PUBLIC_URL + "/ImageNotFound.jpg"}
        />) 
        }
      </Box>
      <ImageList
        sx={{
          width: "100%",
          gridAutoFlow: "column",
          gridTemplateColumns: "repeat(auto-fit, 160px) !important",
          gridAutoColumns: "160px",
        }}
        rowHeight={100}
      >
        {imageData.map((imgObj, index) => (
          <ImageListItem
            key={index}
            css={subImg}
            onClick={() => onClickImg(index)}
          >
            <img src={imgObj.img} alt={imgObj.title} />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  );
};

export default Gallery;
